import { render, staticRenderFns } from "./extras-overview-pdf.vue?vue&type=template&id=4c151288&"
import script from "./extras-overview-pdf.vue?vue&type=script&lang=js&"
export * from "./extras-overview-pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports